import React from 'react';
import { ChatIcon, FormIcon } from '../../components/icons';
export const formLayoutDefaultOptions = [
    {
        value: 'form',
        label: 'Form',
        icon: FormIcon,
        description: 'Traditional form layout'
    },
    {
        value: 'chat',
        label: 'Chat Only',
        icon: ChatIcon,
        description: 'Conversational interface'
    },
    // {
    //   value: 'slack',
    //   label: 'Slack',
    //   icon: SlackIcon,
    //   description: 'Slack integration layout'
    // }
];
export const FormLayoutSelector = ({ selectedLayout, onLayoutChange, title = "Layout Type", options = formLayoutDefaultOptions }) => {
    return (React.createElement("div", { className: "mb-5" },
        React.createElement("label", { className: "block text-sm font-medium text-gray-700 mb-2" }, title),
        React.createElement("div", { className: "grid grid-cols-2 md:grid-cols-3 gap-4" }, options.map((option) => {
            const IconComponent = option.icon;
            const isSelected = selectedLayout === option.value;
            return (React.createElement("div", { key: option.value, className: `border rounded-lg p-4 flex flex-row items-center cursor-pointer transition-all ${isSelected
                    ? 'border-orange-500 bg-orange-50'
                    : 'border-gray-200 hover:border-gray-300'}`, onClick: () => onLayoutChange(option.value) },
                React.createElement("div", { className: "h-10 w-10 bg-gray-100 rounded flex items-center justify-center" },
                    React.createElement(IconComponent, { className: "text-gray-500" })),
                React.createElement("div", { className: "flex flex-col mx-2" },
                    React.createElement("span", { className: "text-sm font-medium" }, option.label),
                    option.description && (React.createElement("span", { className: "text-xs text-gray-500 mt-1" }, option.description)))));
        }))));
};
export default FormLayoutSelector;
